/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
import { includes, get } from 'lodash';
import {
    EVENT_UPDATE_EDITOR_STATUS,
    DOM_EVENT_KEYDOWN,
    DOM_EVENT_UP,
    DOM_EVENT_FOCUS,
    DOM_EVENT_BLUR,
    DOM_VK_TAB,
    DOM_VK_RETURN,
    DOM_VK_LEFT,
    DOM_VK_UP,
    DOM_VK_RIGHT,
    DOM_VK_DOWN,
    TYPE_SELECT_OPTION_RIGHT,
    CLASS_NAME_EDITOR_CONTAINER,
    SECTION_TYPE_SAMPLE,
    DOM_EVENT_MOUSE_UP,
} from '../constants';

export default {
    data() {
        return {
            baseMixin__timerUpdateEditorStatus: null,
            baseMixin__editorStatus: '',
        };
    },
    methods: {
        baseMixin__bindKeywordDownEvents() {
            this.$editor
                .off(DOM_EVENT_KEYDOWN).on(DOM_EVENT_KEYDOWN, (e) => {
                    if (!includes(e.target.className, CLASS_NAME_EDITOR_CONTAINER)) {
                        return;
                    }

                    const { keyCode } = e;

                    if ((keyCode === DOM_VK_TAB || keyCode === DOM_VK_RETURN) && this.dropData && this.dropData.data) {
                        this.putSelectedOptionIntoEditor(TYPE_SELECT_OPTION_RIGHT, e);
                        e.preventDefault();
                        return;
                    }

                    if (this.dropData && this.suggestionList.length > 0 && (keyCode === DOM_VK_UP || keyCode === DOM_VK_DOWN)) {
                        e.preventDefault();
                        this.baseMixin__updatePreSelectedOption(keyCode);
                    }

                    if (keyCode === DOM_VK_RETURN) {
                        this.config.submitCallBack && this.config.submitCallBack();
                        this.$node.blur();
                        e.preventDefault();
                    }
                }).off(DOM_EVENT_UP).on(DOM_EVENT_UP, (e) => {
                    const { keyCode } = e;
                    if (keyCode === DOM_VK_RIGHT || keyCode === DOM_VK_LEFT) {
                        this.getSuggestion();
                    }
                    if (keyCode === DOM_VK_RIGHT || keyCode === DOM_VK_LEFT || keyCode === DOM_VK_UP || keyCode === DOM_VK_DOWN) {
                        this.range = this.getRange();
                    }
                })
                .off(DOM_EVENT_FOCUS)
                .on(DOM_EVENT_FOCUS, (e) => {
                    this.baseMixin__updateEditorStatus(DOM_EVENT_FOCUS);
                    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                })
                .off(DOM_EVENT_BLUR)
                .on(DOM_EVENT_BLUR, () => {
                    this.baseMixin__updateEditorStatus(DOM_EVENT_BLUR);
                })
                .off(DOM_EVENT_MOUSE_UP)
                .on(DOM_EVENT_MOUSE_UP, () => {
                    this.range = this.getRange();
                });
        },
        baseMixin__updateEditorStatus(status) {
            this.baseMixin__editorStatus = status;
            this.baseMixin__timerUpdateEditorStatus = null;
            /**
         * 组件外部接受到该事件时，如果 status = 'blur'，则会清空 suggestionList
         */

            this.$emit(EVENT_UPDATE_EDITOR_STATUS, { status });
            /**
         * status = 'blur' 会清空 suggestionList, 所以 只在 status = 'focus’ 情况下
         */
            if (status === DOM_EVENT_FOCUS && !this.inputModeMixin__query.trim()) {
                this.getSuggestion();
            }
            if (status === DOM_EVENT_BLUR && !this.config.noAutoScroll) {
                this.$node.scrollLeft = 0;
                this.$node.scrollTop = 0;
                if (this.divMode) {
                    this.divModeMixin__preUpdateQuery();
                }
            }
        },
        baseMixin__updatePreSelectedOption(keyCode) {
            const section = get(this.suggestionList, '[0].section');
            if (section === SECTION_TYPE_SAMPLE) return;
            if (keyCode === DOM_VK_UP) {
                if (this.dropData.selectIndex > 0) {
                    this.dropData.selectIndex--;
                }
            } else {
                this.dropData.selectIndex++;
            }
        },
        baseMixin__updateSelectedIndex(index) {
            this.dropData.selectIndex = index;
        },
    },
};
